import React, {Component} from 'react';
import media from '../MediaQueries.js';
import styled from 'styled-components';

import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button } from 'reactstrap';
import { Link } from 'react-router-dom'
import visitUsBG from '../media/visituspagebackground.jpg'
//import storageNutritionAllergenBG from '../media/recipespagebackground.jpg';
import storageNutritionAllergenBG from '../media/newstoragebackground.jpg';
//import storageNutritionAllergenBG from '../media/newgreybackground.jpg'; light bg

//import mapleBottleBG from '../media/mapleweekendbottle.jpg'
import cows1 from '../media/merch05142022_1.jpg'
import cows2 from '../media/merch05142022_2.jpg'



const AwarenessForSaleSection = (props) => {
	const shopGiftBasketsClick = () => {
		console.log("shop gift baskets");
	}

	return (
	  <FluidContainer fluid>
	    <InternalContainer>
		{/*<Brochureh3>Fun Shirts and All-Season Goodies!</Brochureh3>*/}
		{/*<Brochureh3>Christmas Ideas &  xxx Sweet Treats & New Samplers!</Brochureh3>*/}
		{/*
		<DisplayRow>
			<Col xs="12" sm="3" lg="3">
				<Link to="/Shop">
					<img src={require("../media/3syrupHomePage_Prod67.jpg")}></img>
				</Link>
			</Col>
			<Col xs="12" sm="3" lg="3">
				<Link to="/Shop">
					<img src={require("../media/featuredproduct1.jpg")}></img>
				</Link>
			</Col>
			<Col xs="12" sm="3" lg="3">
				<Link to="/Shop">
					<img src={require("../media/iceCreamTrioHomePage.jpg")}></img>
				</Link>
			</Col>
			<Col xs="12" sm="3" lg="3">
				<Link to="/Shop">
					<img src={require("../media/limitedPancakeMixes.jpg")}></img>
				</Link>
			</Col>
			*/}
			{/*
			<Col xs="12" sm="6" lg="6">
				<Link to="/Shop">
					<img src={require("../media/367a.jpg")}></img>
				</Link>
			</Col>
			<Col xs="12" sm="6" lg="6">
				<Link to="/Shop">
					<img src={require("../media/NewProducts06192024.jpg")}></img>
				</Link>
			</Col>
		*/}
		  {/*</DisplayRow>*/}

			{/*
		  <WordingRow>


			<Col xs="12" sm="12" md="12"> */}
				{/*
				<p>We have some fun summer t-shirts! Tie-dyed & solid colors, and many sizes are available. Also, we are now offering
					two new delicious ice cream toppings that include maple blend & triple delight. Maple blend contains pure maple syrup 
					with a swirl of caramel & triple delight contains pure maple syrup mixed with peanut butter & honey. They turn
					ice cream from tasty to pure decadence.
				</p>
				
				
				<p>
					We have some brand new samplers, including our delicious ice cream topping trio set & our maple sample trio, which features three maple leaf 
					containers of each grade: Amber Rich, Robust, and Very Dark. Also shop our limited edition pancake mixes, gift baskets, syrups, candies, jellies, and more for 
					family, friends, or yourself! 

				</p>
				<br />
				<p>
				If you would like a limited pancake mix in a basket, please order any basket with a pancake flavor & let us know what flavor you would like in the notes section. 

				</p>
			</Col>

			<Col xs="12" style={{display: "flex", justifyContent: "center", marginTop: "30px"}}>
			  	<Link to="/Shop">
				  	<ShopGiftBasketButton>
						<p>Shop</p>
					</ShopGiftBasketButton>
			  	</Link>
			  	<LeavesImg src={require("../media/leavespng1.png")}></LeavesImg>
			</Col>
		  </WordingRow>
			*/}

			
	    	<Brochureh3>Maple Weekend 2025 Open House!</Brochureh3>
	    	<Row>
				{/*
				<p>Thanks to all our friends and family that joined us for Maple Weekend this year. We hope you had a great time and appreciate your support. 
					See you for another great time next year!!!
				</p>*/}
				
				
				<LeftCol xs="12" md="6">
					<a target="_blank" href="https://pattersonmaplefarmsstorage.s3.us-east-1.amazonaws.com/randomimages/openHouse2025.pdf">
							<BrochureImg src={require("../media/mapleWeekendBanner2025.jpg")}> 
							</BrochureImg>
						</a>

					<p>On March 15th & 16th from 10am to 4pm, Patterson Farms will be participating in the
				   	  21st annual <a target="_blank" href="http://www.pamaple.com/2025-maple-weekend.html"><u><b>Potter-Tioga County Maple Weekend!</b></u></a>!<br/><br/>Come join us for a fun filled 
				   	  weekend of demonstrations, tours, history, FREE samples of our pancakes and breakfast sausage topped with maple sugar, and more!
					  <br/><br/>
					  For more detail on this event & our many friends in Tioga & Potter county to visit, 
					  check out <a target="_blank" href="http://www.pamaple.com/2025-maple-weekend.html"><u><b>PA Maple</b></u></a> or our brochure displayed here!
				   	</p>
					   
				
					   

				</LeftCol>

				<RightCol xs="12" md="6">
					  
					<a target="_blank" href="https://pattersonmaplefarmsstorage.s3.us-east-1.amazonaws.com/randomimages/openHouse2025.pdf">
						<BrochureImg src={require("../media/openHouse2025Jpg.jpg")}> 
						</BrochureImg>
					</a>

					  	
				</RightCol>
			    
				
			</Row>
		 
		 {/*
		  <BottleDiv>
			  <BottleImg src={require("../media/mapleweekendbottle.png")}>

			  </BottleImg>
			  <TextInBottleDiv>
				  <h3>Maple Weekend 2024</h3>
				  <p>
				   	  On March 16th & 17th from 10am to 4pm, Patterson Farms will be participating in the
				   	  20th annual Potter-Tioga County Maple Weekend!<br/>Come join us for a fun filled 
				   	  weekend of demonstrations, tours, samples (taste testing), history, and more!
				  </p>
			  </TextInBottleDiv>

		  </BottleDiv>
		*/}


{/*
	    	<StoryDiv>
	    		<Row>
	    			<LeftCol xs="12" md="4">
	    				<a target="_blank" href="https://pcntv.com/channels/">
		    				<FarmImg src={require("../media/PCN Tours_Thanksgiving Marathon.jpg")}> 

		    				</FarmImg>
	    				</a>
	    			</LeftCol>

	    			<RightCol>
			    		<h3>PCN Tours Marathon Featuring Patterson Maple Farms starting Thursday, November 23 at 7AM!</h3>
			    		<p>Some helpful information to watch:</p>
			    		<p>
			    		You can watch this on cable in Pennsylvania. Find your <a target="_blank" href="https://pcntv.com/channels/">channel</a>.
			    		</p>
			    		<p>
			    		You can stream this with PCN Select, available on desktop, mobile, Apple TV, Fire TV, and Roku. Subscriptions can be purchased <a target="_blank" href="https://pcntv.com/membership-signup/">here</a>.
			    		</p>
			    		<p>
			    		PCN can be followed on social media @pcntv (Facebook, Twitter, and YouTube) & @pennsylvaniacablenetwork (Instagram).
			    		</p>
			    		<p>
			    		Also, PCN's weekly newsletter and other informative emails can be found <a target="_blank" href="https://pcntv.com/stay-up-to-date/">here</a>.
			    		</p>
		*/}

			    		{/*
					 	<a target="_blank" href="https://www.facebook.com/permalink.php?story_fbid=1741980479307918&id=264986307007350">
					  		Visit Potter-Tioga
					    </a>
						
	    			</RightCol> 
	    		</Row>
	    	</StoryDiv>*/}


	    {/*
	    <h1>Black Friday Sale!</h1>
	    <p>Patterson Farms is offering 10% off all products this Friday "Black Friday" & Saturday "Small Business Saturday"! This sale is available
	    both days by <b>visiting the store or calling in an order</b>. Visit our store in person & you will be entered in a drawing for a FREE holiday basket!

	    We are closed for Thanksgiving and open our regular hours on Friday 10-5 & Saturday 9-3.
		</p>
		*/}

	    {/*
	    <h1>July Sale!</h1>
	    <p>Throughout July, our 500ml Amber Rich & Medium Glass Gallone Bottles are <ProductLink to="/Shop/sale"><u>25%</u></ProductLink> off!
	    Regularly $15.50, these are on sale for only $11.65. Order yours today!</p>
		*/}
		{/*<h1>New Merchandise In Store!</h1>*/}

	     {/*<p>New Patterson Farms merchandise now available for sale. Hoodied sweatshirts, baseball camo hats, long sleeve & short sleeve silky black shirts, 
	     black winter knit hats, and newly designed t-shirts available! Check out the shop!</p>*/}

	     {/*
		  <ProductLink to="/Shop/sale">
			<ProductImg src={require("../media/06252023_SALEPIC.jpg")}></ProductImg>
		  </ProductLink>
		*/}


		  {/*
	     <CowPics>
		 	<CowPic src={cows1}></CowPic>
		 	<CowPic2 src={cows2}></CowPic2>
	     </CowPics>
		*/}
		{/*<LeavesImg src={require("../media/snowflake.png")}></LeavesImg>*/}

	    {/*
	      <h1>Sale This Month</h1>
		  <p>This month, our 1 lb. bag of maple crunchies will be <ProductLink to="/Shop/sale"><u>10%</u></ProductLink> off. Don't miss out!</p>
		  
		  <ProductLink to="/Shop/sale">
			<ProductImg src={require("../media/31.jpg")}></ProductImg>
		  </ProductLink>
		  
		*/}

	    </InternalContainer>
	  </FluidContainer>
	); 
};

const DisplayRow = styled(Row)`
	.col-12 {
		margin-bottom: 15px;
		${media.sm` margin-bottom: 30px; `} 
		${media.lg` margin-bottom: 15px; `} 
		transition: all 0.5s;
		:hover { transform: translateY(6px); }

		img {
			width: 90%;
			${media.sm` width: 100%;`}
			height: auto;
		}
	}
`;

const WordingRow = styled(Row)`
	margin-top: 10px;

	.col-12, .col-3 {
		img {
			width: 100%;
			height: auto;
			max-width: 100px;
			max-height: 90px;
			position: relative;
			top: 50%;
			transform: translateY(-50%);
			${media.lg` width: 90px; height: 80px;`}
		}
		p {
			color: black;
			text-align: left;
			margin: 0;
		}
	}
`;

const ShopGiftBasketButton = styled(Button)`
  cursor: pointer;
  display: block;
  border: 0px!important;
  color: white!important;
  font-weight: bold!important;
  background-color: #800000!important;
  width: 240px;
  ${media.sm` width: 250px; `}
  ${media.md` width: 290px; `}
  height: 40px;
  line-height: 20px!important;
  transition: all 0.5s;
  margin: 0 auto;

  p {
    cursor: pointer;
    display: inline;
    position: relative;
    transition: 0.5s;
    color: white!important;
  }

  p:after {
    content: '\00bb';
    position: absolute;
    opacity: 0;
    right: -20px;
    transition: 0s;
  }

  :hover p { padding-right: 25px; }
  :hover p:after { opacity: 1; right: 0; }
  :active p:after { opacity: 0; }
  :active { box-shadow: 0 5px #666; transform: translateY(6px); }
`;

const Brochureh3 = styled.h3`
	flex: auto;
	color: white!important;
`;

const BrochureImg = styled.img`
	height: auto;
	width: 100%;
	margin: 0 0 20px 0;

`;

const StoryDiv = styled.div`
	p { color: black; }
`;

const FarmImg = styled.img`
	width: 100%;
	height: auto; 
	display: inline;


`;

const LeftCol = styled(Col)`
	
	margin-bottom: 15px;
    ${media.md` margin-bottom: auto; text-align: left; `}
    
`;

const RightCol = styled(Col)`
    ${media.md`  
    	a { color: sandybrown!important; }
    `}
	h3 { color: black!important; }
`;

const LeavesImg = styled.img`
	width: auto!important;
	height: auto!important;
	max-height: 40px!important;
	${media.md`max-height: 50px!important;`}
	position: absolute!important;
	right: 0;
	bottom: -5px;
`;

const CowPics = styled(Col)`
	
`;

const CowPicOrigSettings = styled.img`
	height: 450px;
	width: 100%;
	margin: 0 auto;
	border: 5px solid sandybrown;

	${media.sm` `}
	${media.md`  `}
	${media.lg` width: 80%; `}
	${media.xl` width: 75%; `}
	${media.xxl` `}
`;

const CowPic = styled.img`
	height: 450px;
	width: 100%;
	margin: 0 auto;
	border: 1px solid sandybrown;

	${media.sm` `}
	${media.md` width: 50%; `}
	${media.lg` `}
	${media.xl` `}
	${media.xxl` `}
`;

const CowPic2 = styled.img`
	height: 450px;
	width: 100%;
	margin: 0 auto;
	border: 1px solid sandybrown;

	${media.sm` `}
	${media.md` width: 50%; `}
	${media.lg` `}
	${media.xl` `}
	${media.xxl` `}
`;

const ProductLink = styled(Link)`
	u { color: white; }
`;
const ProductImg = styled.img`
	width: 60%;
	height: auto;
	transition: all 0.5s;
	:hover { transform: translateY(6px); }
`;

const BottleDiv = styled.div`
	position: relative;

	h3 { text-align: center; }
	p { 
		
		${media.sm` `}
		${media.md`  `}
		${media.lg`  `}
		${media.xl`  `}
		${media.xxl` `}
	}
`;

const TextInBottleDiv = styled.div`
	${media.sm` 
		width: 70%;
		position: absolute;
	    top: 57%;
	    left: 50%;
	    transform: translate(-50%, -50%);
	`}
	${media.md` width: 55%; top: 60%; `}
	${media.lg` width: 40%; top: 66%; `}
	${media.xl` width: 35%;`}

`;

const BottleImg = styled.img`
	display: none;

	${media.sm` width: 85%; height: auto; display: inline;`}
	${media.md` width: 70%;`}
	${media.lg` width: 52%;`}
	${media.xl` width: 45%;`}

`;


const FluidContainer = styled(Container)`
	padding: 20px 0 20px 0!important;
	background-image: url(${storageNutritionAllergenBG}); 
`;

const InternalContainer = styled(Container)`
	text-align: center;
	padding-bottom: 50px;
	h1 { 
		margin: 0 0 20px 0;
		color: white;
	}
	p, h3 {
		color: white!important;
	}
	a { color: sandybrown!important; }
`;


/*
const ListViewContainer = styled(({ listSelected, ...rest }) => <Container {...rest} />)`
  display: ${a => a.listSelected ? "block" : "none"};
  ${media.sm` background-image: url(${smHeroImage}); height: 362px; `}
`;
*/

export default AwarenessForSaleSection;


// WEBPACK FOOTER //
// ./src/components/AwarenessForSaleSection.js